import { components } from '@/common/bag-api';
import { CamelCaseKeys } from '@/common/types/snake-to-camel-case';
import { TransportSide, VehicleKind } from './transport.model';
import { SeatStatus } from '@oskar-frontend/comfort-package';

export interface CoachListData {
	id: number;
	reservation: number;
	userData: {
		id: number;
		firstName: string;
		lastName: string;
	};
	slotVehicles: SlotVehicle[];
	notes: string[];
	hasPack: boolean;
	slotsInReservation: number;
	stopDeparture: StopCoachList;
	stopReturn: StopCoachList;
	seatnumber: SeatNumber | null;
}

interface StopCoachList {
	id: number;
	stop: string;
}

export interface CoachListPayload {
	id: number;
	slotVehicles: (Omit<SlotVehicle, 'vehicle' | 'seat'> & { vehicle: number; seat: number })[];
}

export interface SlotVehicle {
	id: number;
	vehicle: CoachVehicle;
	seat: Seats;
	side: TransportSide;
	order: number;
}

export type CoachSlotGroupItem = Omit<CoachListData, 'slotVehicles'> & {
	slotVehicle: SlotVehicle;
	doubledSlots: boolean;
	vehicleBefore: CoachVehicle;
	vehicleAfter: CoachVehicle;
};

export interface CouchGroupByVehicles {
	vehicle: CoachVehicle;
	type: CouchGroupByVehicleEnum;
	slots: CoachSlotGroupItem[];
	hasDoubledSlots: boolean;
	layout: VehicleLayout;
	order: number;
}

export enum CouchGroupByVehicleEnum {
	BEFORE = 'before',
	AFTER = 'after',
	SINGLE = 'single',
	UNASSIGNED = 'unassigned',
}

export type VehicleLayout = Omit<CamelCaseKeys<components['schemas']['VehicleLayout']>, 'seats'> & {
	seats: Seats[];
};

export type Seats = Omit<CamelCaseKeys<components['schemas']['VehicleSeat']>, 'kind'> & {
	kind: SeatStatus;
};

export interface CoachVehicle {
	id: number;
	name: string;
	vehicleKind: VehicleKind;
	layout: number;
}

export interface Floor {
	level: number;
	layout: VehicleLayout;
}

export type CouchGroupedByVehicleAndLevel = CouchGroupByVehicles & { floors: Floor[] };

export interface SeatNumber {
	id: number;
	slot: number;
	singleDeckDeparture: Seats;
	singleDeckReturn: Seats;
	doubleDeckDeparture: Seats;
	doubleDeckReturn: Seats;
}
